"use client";

import { usePathname } from "next/navigation";
import { ProductCatSlider } from "./product-cat-slider";

type Props = React.ComponentProps<typeof ProductCatSlider>;

export function ProductCatSliderWrapper(props: Props) {
  const pathname = usePathname();
  if (pathname.includes("/checkout")) return null;
  return <ProductCatSlider {...props} />;
}
